import { useState, useEffect } from "react";
import RightSideDetails from "../global/rightSideDetails";
import swal from 'sweetalert2';
import { getVendorMasterAll, getVendorUsersByVendorID } from "../api/vendorAPI";
import AddVendorModal from "./AddVendorModal";
import AddVendorUserModal from "./AddVendorUserModal";
import VendorTemplatesTab from "./VendorTemplatesTab";

const VendorMaster = (props) => {

    const [vendorDetails,    setVendorDetails]     = useState(null);
    const [vendorList,       setVendorList]        = useState([]);
    const [vendorUserList,         setVendorUserList]         = useState([]);
    const [vendorNavState,         setVendorNavState]         = useState('Booking Setting');
    const [vendorUserData,         setVendorUserData]         = useState(null);
    const [showAddVendorUserModal, setShowAddVendorUserModal] = useState(false);
    const [isInit,                 setIsInit]                 = useState(true);
    const [rightSideDetails,       setRightSideDetails]       = useState(false);
    const [showAddModal,           setShowAddModal]           = useState(false);
    const [addModalData,           setAddModalData]           = useState(null);
    const [vendorTemplatesDirty,   setVendorTemplatesDirty]   = useState(false);

    //#region Effects ---->

    useEffect(() => {
        props.title("Partner Master", "vendor-master");
        fetchVendorMaster();
    }, []);

    useEffect(() => {
        if (!isInit) fillDataTable();
    }, [vendorList]);

    useEffect(() => {
        if (rightSideDetails) {
            Config.Core.OpenDrawer();
            setVendorNavState('Booking Setting');
        } else {
            setVendorDetails(null);
            setVendorUserList([]);
            setVendorTemplatesDirty(false);
        }
    }, [rightSideDetails]);

    useEffect(() => {
        if (vendorNavState === 'Vendor Users' && vendorDetails?.ID) {
            fetchVendorUsers(vendorDetails.ID);
        }
    }, [vendorNavState]);

    //#endregion

    //#region Vendor Master ---->

    const fetchVendorMaster = async () => {
        try {
            const vendors = await getVendorMasterAll();
            isInit ? setIsInit(false) : $('#tblVendor').KTDatatable().destroy();
            setVendorList(vendors);
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message,
            });
        }
    };

    const fetchVendorUsers = async (vendorID) => {
        try {
            const users = await getVendorUsersByVendorID(vendorID);
            if(users && users.length > 0) setVendorUserList(users);
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message,
            });
        }
    };

    function fillDataTable() {
        const dataTable = $('#tblVendor').KTDatatable({
            data: {
                saveState : false,
                source    : vendorList,
                pageSize  : 20,
            },
            layout: {
                scroll : true,
                height : $(window).height() - 250,
                footer : false,
            },
            sortable   : true,
            pagination : true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field : 'VendorName',
                    title : 'Partner',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                        <div class="kt-badge kt-badge--xl kt-badge--info">${row.VendorName.substring(0, 1)}</div>
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip">${row.VendorName}</span>
                                        <span class="kt-user-card-v2__desc text-clip">${row.ContactPerson || ''}</span>
                                    </div>
                                </div>`;
                    },
                },
                {
                    field : 'Email',
                    title : 'Email',
                    template: function (row) {
                        return `<span>${row.Email || '-'}</span>`;
                    },
                },
                {
                    field : 'Phone',
                    title : 'Phone',
                    template: function (row) {
                        return `<span>${row.Phone || '-'}</span>`;
                    },
                    width: 130,
                },
                // {
                //     field : 'PaymentMode',
                //     title : 'Payment Mode',
                //     template: function (row) {
                //         return `<span>${row.PaymentMode || '-'}</span>`;
                //     },
                //     width: 130,
                // },
                {
                    field : 'Status',
                    title : 'Status',
                    template: function (row) {
                        return row.Status
                            ? '<span class="kt-badge kt-badge--success kt-badge--pill padding-lr30 padding-tb10">Active</span>'
                            : '<span class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10">Inactive</span>';
                    },
                    width: 100,
                },
            ],
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblVendor .kt-datatable__table').addClass('overflow-x-auto');

        dataTable.on('click', 'tr', function () {
            const index = ($("tr").index(this) - 1);
            if (dataTable.dataSet[index]) {
                setVendorDetails(dataTable.dataSet[index]);
                setRightSideDetails(true);
            }
        });
    }

    const openAddModal = () => {
        setAddModalData(null);
        setShowAddModal(true);
    };

    const openEditModal = () => {
        setAddModalData({ ...vendorDetails });
        setShowAddModal(true);
    };

    const handleVendorSaved = (isEdit) => {
        setShowAddModal(false);
        if (isEdit) closeDrawer();
        fetchVendorMaster();
    };

    const handleTabChange = async (newTab) => {
        if (vendorNavState !== newTab && vendorNavState === 'Vendor Templates' && vendorTemplatesDirty) {
            const result = await swal.fire({
                icon               : 'warning',
                titleText          : 'Unsaved Changes',
                text               : 'You have unsaved template changes. Leave without saving?',
                showCancelButton   : true,
                confirmButtonText  : 'Leave',
                cancelButtonText   : 'Stay',
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-danger margin-r5',
                cancelButtonClass  : 'btn btn-secondary',
            });
            if (!result.isConfirmed) return;
            setVendorTemplatesDirty(false);
        }
        setVendorNavState(newTab);
    };

    const closeDrawer = async () => {
        if (vendorNavState === 'Vendor Templates' && vendorTemplatesDirty) {
            const result = await swal.fire({
                icon               : 'warning',
                titleText          : 'Unsaved Changes',
                text               : 'You have unsaved template changes. Leave without saving?',
                showCancelButton   : true,
                confirmButtonText  : 'Leave',
                cancelButtonText   : 'Stay',
                buttonsStyling     : false,
                confirmButtonClass : 'btn btn-danger margin-r5',
                cancelButtonClass  : 'btn btn-secondary',
            });
            if (!result.isConfirmed) return;
        }
        Config.Core.CloseDrawer();
        setTimeout(() => setRightSideDetails(false), 200);
    };

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input
                                                type="text"
                                                className="form-control clientSearch"
                                                placeholder="Search Partner..."
                                                id="generalSearch"
                                            />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left">
                                                <span><i className="la la-search"></i></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-wrapper">
                                    <div className="kt-portlet__head-actions">
                                        <button
                                            onClick={openAddModal}
                                            type="button"
                                            className="btn btn-brand btn-icon-sm text-white d-inline"
                                        >
                                            <i className="la la-plus"></i>New Partner
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblVendor" className="kt-datatable table-striped clickable"></div>

                            {/* Details Sidebar */}
                            {rightSideDetails && vendorDetails && (
                                <RightSideDetails title="Vendor Details" onCloseDrawer={closeDrawer}>
                                    {/* Profile Widget */}
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget kt-widget--user-profile-3">
                                                <div className="kt-widget__top">
                                                    <div className="kt-widget__pic kt-widget__pic--brand kt-font-brand kt-font-boldest kt-hidden-">
                                                        {vendorDetails.VendorName.substring(0, 1)}
                                                    </div>
                                                    <div className="kt-widget__content">
                                                        <div className="kt-widget__head">
                                                            <span className="kt-widget__username">
                                                                {vendorDetails.VendorName}{' '}
                                                                <span className={`kt-badge kt-badge--${vendorDetails.Status ? 'success' : 'grey'} kt-badge--inline kt-badge--pill padding-lr10`}>
                                                                    {vendorDetails.Status ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </span>
                                                            <div className="kt-widget__action">
                                                                <span className="dropdown">
                                                                    <a
                                                                        className="btn btn-sm btn-clean btn-icon btn-icon-md"
                                                                        data-toggle="dropdown"
                                                                        aria-expanded="true"
                                                                    >
                                                                        <i className="flaticon-more-1"></i>
                                                                    </a>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <a className="dropdown-item" onClick={openEditModal}>
                                                                            <i className="la la-edit"></i>
                                                                            Edit
                                                                        </a>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="kt-widget__subhead padding-t0">
                                                            {vendorDetails.ContactPerson && (
                                                                <span className="padding-r10">
                                                                    <i className="flaticon2-user"></i>
                                                                    {vendorDetails.ContactPerson}
                                                                </span>
                                                            )}
                                                            <br />
                                                            {vendorDetails.Phone && (
                                                                <span className="padding-r10">
                                                                    <i className="flaticon2-phone"></i>
                                                                    {vendorDetails.Phone}
                                                                </span>
                                                            )}
                                                            {vendorDetails.Email && (
                                                                <span className="padding-r10">
                                                                    <i className="flaticon2-new-email"></i>
                                                                    {vendorDetails.Email}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tab Section */}
                                    <div className="kt-portlet kt-portlet--mobile">
                                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                                            <div className="kt-portlet__head-label">
                                                <nav className="file-nav navbar navbar-top">
                                                    <a
                                                        className={vendorNavState === 'Booking Setting' ? 'top-nav-active' : ''}
                                                        onClick={() => handleTabChange('Booking Setting')}
                                                    >
                                                        Booking Setting
                                                    </a>
                                                    <a
                                                        className={vendorNavState === 'Vendor Users' ? 'top-nav-active' : ''}
                                                        onClick={() => handleTabChange('Vendor Users')}
                                                    >
                                                        Partner Users
                                                    </a>
                                                    <a
                                                        className={vendorNavState === 'Vendor Templates' ? 'top-nav-active' : ''}
                                                        onClick={() => handleTabChange('Vendor Templates')}
                                                    >
                                                        Partner Templates
                                                    </a>
                                                </nav>
                                            </div>
                                            <div className="kt-portlet__head-toolbar">
                                                <div className="kt-portlet__head-wrapper">
                                                    <div className="kt-portlet__head-actions">
                                                        {vendorNavState === 'Vendor Users' && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-label-brand btn-block margin-0"
                                                                onClick={() => { setVendorUserData(null); setShowAddVendorUserModal(true); }}
                                                            >
                                                                <i className="la la-plus"></i>Add User
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__body padding-t0">

                                            {/* Booking Setting Tab */}
                                            {vendorNavState === 'Booking Setting' && (
                                                <div className="row margin-t10">
                                                    <div className="col-6">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-8 kt-font-bold">Max Weekday Bookings</label>
                                                            <div className="col-lg-4">
                                                                <span className="form-control-plaintext">{vendorDetails.MaxWeekdayBookings ?? '-'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-8 kt-font-bold">Max Weekend Bookings</label>
                                                            <div className="col-lg-4">
                                                                <span className="form-control-plaintext">{vendorDetails.MaxWeekendBookings ?? '-'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-8 kt-font-bold">Cancellation Hours</label>
                                                            <div className="col-lg-4">
                                                                <span className="form-control-plaintext">{vendorDetails.CancellationHours ?? '-'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-8 kt-font-bold">Payment Mode</label>
                                                            <div className="col-lg-4">
                                                                <span className="form-control-plaintext">{vendorDetails.PaymentMode || '-'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-8 kt-font-bold">Invoice Slug</label>
                                                            <div className="col-lg-4">
                                                                <span className="form-control-plaintext">{vendorDetails.Slug || '-'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-8 kt-font-bold">Allow 9 Hole</label>
                                                            <div className="col-lg-4">
                                                                {vendorDetails.Allow9Hole
                                                                    ? <span className="kt-badge kt-badge--success kt-badge--pill padding-lr20 padding-tb5">Yes</span>
                                                                    : <span className="kt-badge kt-badge--grey kt-badge--pill padding-lr20 padding-tb5">No</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-8 kt-font-bold">Allow 18 Hole</label>
                                                            <div className="col-lg-4">
                                                                {vendorDetails.Allow18Hole
                                                                    ? <span className="kt-badge kt-badge--success kt-badge--pill padding-lr20 padding-tb5">Yes</span>
                                                                    : <span className="kt-badge kt-badge--grey kt-badge--pill padding-lr20 padding-tb5">No</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Vendor Templates Tab */}
                                            {vendorNavState === 'Vendor Templates' && (
                                                <VendorTemplatesTab
                                                    vendorID={vendorDetails.ID}
                                                    onDirtyChange={setVendorTemplatesDirty}
                                                />
                                            )}

                                            {/* Vendor Users Tab */}
                                            {vendorNavState === 'Vendor Users' && (
                                                <div className="margin-t10">
                                                    {vendorUserList && vendorUserList.length > 0 ? (
                                                        <table className="table table-striped table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Email</th>
                                                                    <th>Phone</th>
                                                                    <th>Status</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {vendorUserList.map((u, i) => (
                                                                    <tr key={i}>
                                                                        <td>{u.FullName || '-'}</td>
                                                                        <td>{u.Email || '-'}</td>
                                                                        <td>{u.Phone || u.Mobile || '-'}</td>
                                                                        <td>
                                                                            {u.Status
                                                                                ? <span className="kt-badge kt-badge--success kt-badge--pill padding-lr20 padding-tb5">Active</span>
                                                                                : <span className="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb5">Inactive</span>
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <button 
                                                                                type="button"
                                                                                className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10"
                                                                                // onClick={() => editCoachAdvanceBookingHandler(p)}
                                                                                onClick={() => { setVendorUserData(u); setShowAddVendorUserModal(true); }}
                                                                            >  
                                                                                            
                                                                                <i className="flaticon2-edit"></i>
                                                                            </button> 
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <div className="text-center padding-tb30">
                                                            <span className="kt-font-bold kt-font-lg text-muted">No users.</span>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </RightSideDetails>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <AddVendorModal
                show={showAddModal}
                onDismissModal={() => setShowAddModal(false)}
                vendorData={addModalData}
                onSave={handleVendorSaved}
            />

            <AddVendorUserModal
                show={showAddVendorUserModal}
                onDismissModal={() => setShowAddVendorUserModal(false)}
                vendorID={vendorDetails?.ID}
                vendorUserData={vendorUserData}
                onSave={() => fetchVendorUsers(vendorDetails.ID)}
            />
        </>
    );
};

export default VendorMaster;
